import { isOneOfTags } from 'anodum';
import {
  BOLD_TAG,
  ITALIC_TAG,
  ALTERNATIVE_ITALIC,
  ALTERNATIVE_BOLD,
  DEFAULT_BLOCK_TAG,
  UNDERLINE_TAG,
  STRIKETHROUGH_TAG,
} from '../constants/editable-elements';
import hasBoldStyle from '../verifiers/has-bold-style';
import hasItalicStyle from '../verifiers/has-italic-style';
import hasUnderlineStyle from '../verifiers/has-underline-style';
import isRolledBackTagByStyle from '../verifiers/is-rolled-back-tag-by-style';
import isBlockElement from '../verifiers/is-block-element';
import hasStrikethroughStyles from '../verifiers/has-strikethrough-styles';

const defineSupportedTags = (element) => {
  const definedTags = [];
  if (isBlockElement(element)) definedTags.push(DEFAULT_BLOCK_TAG);

  if (!isRolledBackTagByStyle(element)) {
    if (isOneOfTags(element, ALTERNATIVE_BOLD)) definedTags.push(BOLD_TAG);
    if (isOneOfTags(element, ALTERNATIVE_ITALIC)) definedTags.push(ITALIC_TAG);
  }

  if (hasBoldStyle(element)) definedTags.push(BOLD_TAG);
  if (hasItalicStyle(element)) definedTags.push(ITALIC_TAG);
  if (hasUnderlineStyle(element)) definedTags.push(UNDERLINE_TAG);
  if (hasStrikethroughStyles(element)) definedTags.push(STRIKETHROUGH_TAG);

  return Array.from(new Set(definedTags));
};

export default defineSupportedTags;
